module.exports = __webpack_public_path__ + "static/media/hawaii.3d37a52c.svg";